module.exports = __webpack_public_path__ + "static/media/bg13.d6adf5d4.jpg";